import { FadeSlideIn, ScalePopIn } from './Animations';
import { Button } from './Button';
import { cn } from './cn';
import { ActionProps } from './DataList';

export interface EmptyStateProps {
  title: string;
  description: string;
  actionProps?: ActionProps;
  bannerWidth?: number;
  className?: string;
}

export const EmptyState = ({ title, description, actionProps, bannerWidth, className }: EmptyStateProps) => {
  return (
    <FadeSlideIn
      className={cn('flex flex-col items-center justify-center py-16 px-8 text-center', className)}
      style={bannerWidth ? { maxWidth: bannerWidth } : undefined}
      offset={12}
      transition={{ duration: 0.4 }}
    >
      <ScalePopIn className="mb-3 h-14 w-14 rounded-full bg-text-muted/10 flex items-center justify-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="h-7 w-7 text-text-disabled"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
          />
        </svg>
      </ScalePopIn>
      <h3 className="type-h3 text-text-primary">{title}</h3>
      <p className="mt-1.5 type-body-sm-relaxed text-text-secondary max-w-md">{description}</p>
      {actionProps?.title && actionProps?.onClick && (
        <FadeSlideIn delay={0.25}>
          <Button variant="primary" onClick={actionProps.onClick} className="mt-5">
            {actionProps.icon}
            {actionProps.title}
          </Button>
        </FadeSlideIn>
      )}
    </FadeSlideIn>
  );
};
